/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_header_oer9 = /** @type {(inputs: {}) => string} */ () => {
	return `What are OER?`
};

const fr_header_oer9 = /** @type {(inputs: {}) => string} */ () => {
	return `REL`
};

const de_header_oer9 = /** @type {(inputs: {}) => string} */ () => {
	return `Was sind OER?`
};

const es_header_oer9 = /** @type {(inputs: {}) => string} */ () => {
	return `¿Qué son los REA?`
};

const it_header_oer9 = /** @type {(inputs: {}) => string} */ () => {
	return `Cosa sono le REA?`
};

const ar_header_oer9 = /** @type {(inputs: {}) => string} */ () => {
	return `ما هي الموارد التعليمية المفتوحة؟`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const header_oer9 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.header_oer9(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("header_oer9", locale)
	if (locale === "en") return en_header_oer9(inputs)
	if (locale === "fr") return fr_header_oer9(inputs)
	if (locale === "de") return de_header_oer9(inputs)
	if (locale === "es") return es_header_oer9(inputs)
	if (locale === "it") return it_header_oer9(inputs)
	return ar_header_oer9(inputs)
};
export { header_oer9 as "HEADER_OER" }